import { EntityType } from '../../types/enums';
import { Action } from '../types/types';

export interface CommToggleState {
    version: number;
    entityValue: {
        producer: number;
        allOnCanvas: boolean;
        presenter: string;
    }[];
}

export const defaultCommToggleState: CommToggleState = {
	version: 0,
	entityValue: [],
};

export const CommToggleReducer = (
	state: CommToggleState = defaultCommToggleState,
	action: Action,
) => {
	switch (action.type) {
		case EntityType.commsToggle:
			return action.payload;
		default:
			return state;
	}
};
